/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Portal API Gateway
 * OpenAPI spec version: 2.0.0
 */

/**
 * Rate name of meter register
 */
export type MeterRegisterRateName =
  (typeof MeterRegisterRateName)[keyof typeof MeterRegisterRateName]

export const MeterRegisterRateName = {
  day: "day",
  night: "night",
  standard: "standard",
} as const
